<template>
    <v-container>
        <div v-if="item && item.type === 'wells'">
            <adapt-settings v-model="task" :problem="item"></adapt-settings>
            <v-btn large color="primary" @click="saveTaskAndGotoNextStep" class="mt-4" :disabled="!isValid">Далее</v-btn>
        </div>
        <div v-else>
            <adapt-settings v-model="task" :problem="item"></adapt-settings>
            <div class="d-flex align-center">                
                <v-btn large color="primary" @click="saveTaskAndGotoNextStep" class="mt-4" :disabled="!isValid">Далее</v-btn>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="downloadJson" class="mt-4" :disabled="!isValid">Скачать JSON</v-btn>
            </div>
        </div>
    </v-container>
</template>

<script>
import {downloadJson} from "@/utils";
import AdaptSettings from "@/components/Problem/AdaptSettings.vue";

export default {
    components: { AdaptSettings },
    data() {
        return {
            item: {},
            task: null,
            predictTask: null,
            wellsTask: null,
        }
    },
    async created() {
        this.$store.commit('task/setWellsItem', null);
        this.$store.commit('grid/resetData');

        if (this.problemId) {
            await this.load();
        }
    },
    watch: {
        async problemId() {
            this.$store.commit('grid/resetData');
            await this.load();
        },
    },
    methods: {
        async load() {
            let item = await this.$store.dispatch('problem/loadItem', this.problemId);
            if (item?.problem) {
                this.item = item?.problem;
                this.editState = item?.state;
            }
            else if (item) {
                this.item = item;
            }
        },
        async saveTaskAndGotoNextStep() {
            if (this.item?.type === 'wells') {
                await this.saveWellsTask();
            }
            else {
                await this.saveTask();
            }
            if (this.task && this.task?.id && !this.saveError) {
                this.gotoNextStep();
            }
        },
        async saveTask() {
            if (!this.task) {
                return;
            }

            this.task = await this.$store.dispatch('task/newItem', this.task);
        },
        downloadJson() {
            downloadJson(this.task);
        },
        async savePredictTask() {
            if (!this.predictTask) {
                return;
            }

            if (this.predictTask.id) {
                this.predictTask.status = null;
                await this.$store.dispatch('task/saveItem', this.predictTask);
            }
            else {
                await this.$store.dispatch('task/newItem', this.predictTask);
                await this.$store.dispatch('task/loadItems', { problemId: this.task.problemId });
                await this.$store.dispatch('task/setPredictItem', this.task.problemId);
            }
        },
        async saveWellsTask() {
            if (!this.wellsTask) {
                return;
            }

            if (this.wellsTask.id) {
                this.wellsTask.status = null;
                await this.$store.dispatch('task/saveItem', this.wellsTask);
            }
            else {
                await this.$store.dispatch('task/newItem', this.wellsTask);
                await this.$store.dispatch('task/loadItems', { problemId: this.wellsTask.problemId });
                await this.$store.dispatch('task/setWellsItem', this.wellsTask.problemId);
            }
        },
        gotoNextStep() {
            return this.$router.push({ name: 'taskProgress', params: { id: this.task.id } });
        },
        
    },
    computed: {
        problemId() {
            return this.$route.params && this.$route.params.id
                ? this.$route.params.id || false
                : false;
        },
        saveError() {
            return this.$store.state.task.lastError;
        },
        isValid() {
            return Boolean(this.task);
        }
    }
}
</script>

<style lang="scss">
    .problem-edit {
        height: 100%;
        position: relative;
    }
</style>
